export default __webpack_public_path__ + "static/media/yale-mark.59f2ddfb.svg";